'use client'

import { useCallback, useState } from 'react'
import { ChatCore } from './ChatCore'
import { useChatContext } from './ChatProvider'
import { FloatingChatLayout } from './FloatingChatLayout'

export default function FloatingChatWidget() {
  const { isStaffLoggedIn } = useChatContext()
  const [shouldOpenChat, setShouldOpenChat] = useState(false)

  // Add welcome message when session is created
  const handleSessionCreated = (sessionId: string) => {
    console.log('Session created:', sessionId)
  }

  const handleMessageSent = () => {
    // Optional: Handle message sent events
  }

  const handleMessageReceived = () => {
    // Optional: Handle message received events
  }

  const handleHandoverRequested = () => {
    // Optional: Handle handover requested events
  }

  const handleHandoverCompleted = () => {
    // Optional: Handle handover completed events
  }

  const handleChatOpened = useCallback(() => setShouldOpenChat(false), [])

  const handleOpenChat = () => {
    console.log('💬 [WIDGET] Entry node requested auto-open chat')
    setShouldOpenChat(true)
  }

  return (
    <div data-floating-chat>
      <ChatCore
        onSessionCreated={handleSessionCreated}
        onMessageSent={handleMessageSent}
        onMessageReceived={handleMessageReceived}
        onHandoverRequested={handleHandoverRequested}
        onHandoverCompleted={handleHandoverCompleted}
        onOpenChat={handleOpenChat}
      >
        {renderProps => (
          <FloatingChatLayout
            renderProps={renderProps}
            isStaffLoggedIn={isStaffLoggedIn}
            shouldOpenChat={shouldOpenChat}
            onChatOpened={handleChatOpened}
          />
        )}
      </ChatCore>
    </div>
  )
}
